import { gql } from "@apollo/client";
import { ReportData } from "../../../../Definitions";
import { REPORT_FRAGMENT } from "./getArchivedReportsCall";
import { Def_MutationResponse } from "../../UserCalls/GQLCalls/userCalls";

export const CREATE_REPORT = gql`
  mutation CreateReport($domain: String!, $name: String!, $startDate: Long!, $endDate: Long!, $archived: Boolean!, $filterParameter: [[FilterInput!]!]!, $dataLevel: Int!, $ifFetchData: Boolean!) {
    report {
      create(domain: $domain, name: $name, start_date: $startDate, end_date: $endDate, archived: $archived, filter: $filterParameter, data_level: $dataLevel) {
        success
        message
        code
        updatedValues{
        ...ReportFields         
        }
      }
    }
  }
  ${REPORT_FRAGMENT}
`
export interface MutateReportResponse extends Def_MutationResponse {
  updatedValues?: ReportData[]
}

export interface CreateReportResponse {
  report: {
    create: MutateReportResponse 
  }
}